import Backgrounds from 'Event/template/Panels/Dashboard/Resources/Backgrounds'
import ResourceList from 'Event/template/Panels/Dashboard/Resources/ResourceList'
import React from 'react'

export default function Resources() {
  return (
    <>
      <ResourceList />
      <Backgrounds />
    </>
  )
}
